// src/hooks/useFetchOnMount.js
// Runs an async fetch function once on mount, but only if the data array is empty.
// Replaces the repeated pattern:
//
//   useEffect(() => {
//     (async () => {
//       if (data.length === 0) await fetchData();
//     })();
//     // eslint-disable-next-line
//   }, []);
//
// Usage:
//   useFetchOnMount(myDataArray, fetchMyData);

import { useEffect } from "react";

/**
 * @param {Array}    data      - The state array to check. Fetch is skipped when non-empty.
 * @param {Function} fetchFn   - Async function to call when data is empty.
 */
export function useFetchOnMount(data, fetchFn) {
  useEffect(() => {
    if (data.length === 0) {
      fetchFn();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
